import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { GlobalFooter } from '@nexus/fff-global-footer';
import { Helmet } from 'react-helmet';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { requestBoostsData } from 'services/actions/campaignActions';

import useCustomizeCampaignData from 'hooks/useCustomizeCampaignData';
import { SUBSCRIPTIONS_FILTERS, PROGRESS_BAR_ITEMS } from 'utils/boosts';
import { CUSTOMIZE_CAMPAIGN_STATUS } from 'utils/campaign';

import cookie, { COOKIE_NAMES } from 'utils/cookie';

import GlobalNav from 'shared-components/GlobalNav/GlobalNav';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import BoostsHeader from 'shared-components/BoostsHeader/BoostsHeader';
import NavigationButtons from 'shared-components/NavigationButtons/NavigationButtons';
import PageProgress from 'shared-components/PageProgress/PageProgress';
import SubscriptionConfirmationModal from 'shared-components/SubscriptionConfirmationModal/SubscriptionConfirmationModal';
import ProductGrid from 'Scenes/Products/ProductGrid/ProductGrid';

const MAX_PAGES = 2;
const CURRENT_NODE = 2;
const CURRENT_PAGE = 1;
const HAS_SUBSCRIPTIONS = true; //TODO: get this from User's info

const NEWLY_ADDED_SECTION = {
  title: 'Newly Added Subscriptions',
  subtitle: 'Be the first to subscribe to these new offers',
};

const Subscriptions = ({ getBoostsData }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { loading: loadingCustomizeCampaign, customizeCampaign } =
    useCustomizeCampaignData(true);
  const { rateAndReview: rateAndReviewFF } = useFlags();
  const [
    showSubscriptionConfirmationModal,
    setShowSubscriptionConfirmationModal,
  ] = useState(false);
  const isCookiePresent = cookie.get(COOKIE_NAMES.boostsSubscriptionModal);
  const renderSubscriptionConfirmationModal =
    HAS_SUBSCRIPTIONS && !isCookiePresent;

  const toggleSubscriptionConfirmationModal = () => {
    setShowSubscriptionConfirmationModal((prevState) => !prevState);
  };

  const onClickSubscribe = () => {
    if (!isCookiePresent) {
      cookie.set(COOKIE_NAMES.boostsSubscriptionModal, true, 365);
      toggleSubscriptionConfirmationModal();
    }
    history.push('/boosts-q2');
  };

  const onClickBack = () => {
    window.location.href = '/customize/?q=6';
  };

  const onClickNext = () => {
    if (renderSubscriptionConfirmationModal) {
      toggleSubscriptionConfirmationModal();
    } else {
      history.push('/boosts-q2');
    }
  };

  useEffect(() => {
    const isCustomizeCampaignOpen =
      customizeCampaign?.userInfo?.customizePage ===
      CUSTOMIZE_CAMPAIGN_STATUS.open;
    if (isCustomizeCampaignOpen) {
      getBoostsData({
        pathname,
        rateAndReviewFF,
      });
    }
  }, [customizeCampaign]);

  if (loadingCustomizeCampaign) return null;

  return (
    <>
      <Helmet>
        <title>FabFitFun - Beauty, Fitness, Lifestyle</title>
        <meta
          property="description"
          content="Delivering happiness and well-being to everyone, everywhere Join FabFitFun today"
        />
        <meta
          property="og:title"
          content="FabFitFun - Beauty, Fitness, Lifestyle"
        />
      </Helmet>
      <GlobalNav />
      <PageProgress
        list={PROGRESS_BAR_ITEMS}
        currentNode={CURRENT_NODE}
        maxPages={MAX_PAGES}
        currentPage={CURRENT_PAGE}
      />
      <PageContainer>
        <BoostsHeader
          title={NEWLY_ADDED_SECTION.title}
          subtitle={NEWLY_ADDED_SECTION.subtitle}
        />
        <ProductGrid type="IN_STOCK" selectedCategoryId={null} />
        <NavigationButtons
          onClickBack={onClickBack}
          onClickNext={onClickNext}
        />
      </PageContainer>
      <GlobalFooter />
      <SubscriptionConfirmationModal
        isOpen={showSubscriptionConfirmationModal}
        onClickCancel={toggleSubscriptionConfirmationModal}
        onClickSubscribe={onClickSubscribe}
      />
    </>
  );
};

Subscriptions.propTypes = {
  getBoostsData: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getBoostsData: requestBoostsData,
};

export default connect(null, mapDispatchToProps)(Subscriptions);
